/* tslint:disable */
/* eslint-disable */
/**
 * esign
 * eSign template authoring and request management service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PrepareTemplateErrorCode = {
    RawInvalidPrefix: 'raw_invalid_prefix',
    RawNotFound: 'raw_not_found',
    Encrypted: 'encrypted',
    Malformed: 'malformed',
    Timeout: 'timeout',
    Internal: 'internal',
} as const;
export type PrepareTemplateErrorCode = typeof PrepareTemplateErrorCode[keyof typeof PrepareTemplateErrorCode];


export function instanceOfPrepareTemplateErrorCode(value: any): boolean {
    for (const key in PrepareTemplateErrorCode) {
        if (Object.prototype.hasOwnProperty.call(PrepareTemplateErrorCode, key)) {
            if (PrepareTemplateErrorCode[key as keyof typeof PrepareTemplateErrorCode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PrepareTemplateErrorCodeFromJSON(json: any): PrepareTemplateErrorCode {
    return PrepareTemplateErrorCodeFromJSONTyped(json, false);
}

export function PrepareTemplateErrorCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrepareTemplateErrorCode {
    return json as PrepareTemplateErrorCode;
}

export function PrepareTemplateErrorCodeToJSON(value?: PrepareTemplateErrorCode | null): any {
    return value as any;
}

export function PrepareTemplateErrorCodeToJSONTyped(value: any, ignoreDiscriminator: boolean): PrepareTemplateErrorCode {
    return value as PrepareTemplateErrorCode;
}

